module.exports = __webpack_public_path__ + "img/selma.1b8b4362.png";